import { render, staticRenderFns } from "./accurate-flow.vue?vue&type=template&id=fa074a90&scoped=true"
import script from "./accurate-flow.vue?vue&type=script&lang=js"
export * from "./accurate-flow.vue?vue&type=script&lang=js"
import style0 from "./accurate-flow.vue?vue&type=style&index=0&id=fa074a90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa074a90",
  null
  
)

export default component.exports